module.exports = __webpack_public_path__ + "d2a66abf59ac69c8975337d309c5368b.svg";